import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck } from "lucide-react";
import { api } from "@/lib/api";

export const FIELDS = [["name", "Full name"], ["phone", "Mobile number"], ["line1", "House / street"], ["line2", "Area / landmark (optional)"], ["city", "City"], ["state", "State"], ["pincode", "PIN code"]];
export const EMPTY_ADDRESS = { name: "", phone: "", line1: "", line2: "", city: "", state: "", pincode: "" };

export function DeliveryEstimate({ pincode, kind = "book", prefix = "checkout" }) {
  const [est, setEst] = useState(null);
  const pin = (pincode || "").replace(/\D/g, "");
  useEffect(() => {
    if (!/^[1-9][0-9]{5}$/.test(pin)) { setEst(null); return; }
    let live = true;
    api.get("/delivery-estimate", { params: { pincode: pin, kind } }).then((r) => live && setEst(r.data)).catch(() => live && setEst(null));
    return () => { live = false; };
  }, [pin, kind]);
  if (!est) return null;
  return (
    <p className="mt-3 flex items-start gap-2 rounded-md bg-[#EEF3FF] px-3 py-2 text-sm text-[#2F3E8F]" data-testid={`${prefix}-delivery-estimate`}>
      <Truck className="mt-0.5 h-4 w-4 shrink-0" />
      <span>Estimated delivery to {est.pincode}: <strong data-testid={`${prefix}-delivery-window`}>{est.label}</strong>
        <span className="block text-xs text-[#5E6AA8]">{est.zone} · {est.production_days[0]}–{est.production_days[1]} days to {kind === "poster" ? "print" : "print & bind"} + {est.transit_days[0]}–{est.transit_days[1]} days in transit</span>
      </span>
    </p>
  );
}

export default function AddressFields({ addr, setAddr, prefix = "checkout", kind = "book" }) {
  return (
    <div>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, l]) => (
          <div key={k} className={`space-y-1.5 ${["line1", "line2", "name"].includes(k) ? "sm:col-span-2" : ""}`}>
            <Label htmlFor={`${prefix}-${k}`}>{l}</Label>
            <Input id={`${prefix}-${k}`} data-testid={`${prefix}-${k}-input`} required={k !== "line2"} value={addr[k]}
              inputMode={k === "pincode" || k === "phone" ? "numeric" : undefined}
              onChange={(e) => setAddr({ ...addr, [k]: e.target.value })} className="h-11 bg-white" />
          </div>
        ))}
      </div>
      <DeliveryEstimate pincode={addr.pincode} kind={kind} prefix={prefix} />
    </div>
  );
}
